// extracted by mini-css-extract-plugin
module.exports = {"documentsViewPlaceholder":"DocumentsView_documentsViewPlaceholder__30657","importing":"DocumentsView_importing__xxlhn","error":"DocumentsView_error__386Tc"};